import { render, staticRenderFns } from "./member_assets.vue?vue&type=template&id=32ce8f66&scoped=true&"
import script from "./member_assets.vue?vue&type=script&lang=js&"
export * from "./member_assets.vue?vue&type=script&lang=js&"
import style0 from "./member_assets.vue?vue&type=style&index=0&id=32ce8f66&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ce8f66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32ce8f66')) {
      api.createRecord('32ce8f66', component.options)
    } else {
      api.reload('32ce8f66', component.options)
    }
    module.hot.accept("./member_assets.vue?vue&type=template&id=32ce8f66&scoped=true&", function () {
      api.rerender('32ce8f66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/memberCenter/views/member_management/components/member_assets.vue"
export default component.exports